import { supabase } from './api'

export async function getSelectionsForStudent(studentId) {
	const { data, error } = await supabase.from('studentlistcollege').select().eq('studentId', studentId)
	if (error) {
		throw new Error(`Failed to fetch student college selections: ${error.message}`)
	}
	return data || []
}

export async function addSelections(rows) {
	if (!rows.length) return []
	const { data, error } = await supabase.from('studentlistcollege').insert(rows).select()
	if (error) {
		throw new Error(`Failed to add college selections: ${error.message}`)
	}
	return data
}

export async function deleteSelectionById(id) {
	const { error } = await supabase.from('studentlistcollege').delete().eq('id', id)
	if (error) {
		throw new Error(`Failed to remove college selection: ${error.message}`)
	}
}
